module.exports = __webpack_public_path__ + "static/media/Beneficiary_Transfer.87281159.svg";